/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { usageGetUsageTiers } from "../funcs/usageGetUsageTiers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UsageTiers } from "../models/components/usagetiers.js";
import { unwrapAsync } from "../types/fp.js";
export type GetUsageTiersQueryData = UsageTiers;

export function prefetchGetUsageTiers(
  queryClient: QueryClient,
  client$: GramCore,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetUsageTiersQuery(
      client$,
      options,
    ),
  });
}

export function buildGetUsageTiersQuery(
  client$: GramCore,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GetUsageTiersQueryData>;
} {
  return {
    queryKey: queryKeyGetUsageTiers(),
    queryFn: async function getUsageTiersQueryFn(
      ctx,
    ): Promise<GetUsageTiersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(usageGetUsageTiers(
        client$,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetUsageTiers(): QueryKey {
  return ["@gram/client", "usage", "getUsageTiers"];
}
